import { SignUp } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { CornerLanguageSelector } from '@/components/corner-language-selector';
import { AuthPageFooter } from '@/components/auth/auth-page-footer';
import { AuthPageSiteLinks } from '@/components/auth/auth-page-site-links';
import { keepSignInSearch } from '@/config/sign-in-redirect';
import { usePageTitle } from '@/hooks/use-page-title';

export const Route = createFileRoute('/sign-up/$')({
    validateSearch: keepSignInSearch,
    component: SignUpPage,
});

function SignUpPage() {
    const { t } = useTranslation();
    usePageTitle(t('pageTitle.signUp'));
    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4">
            <CornerLanguageSelector />
            <AuthPageSiteLinks />
            <SignUp
                routing="path"
                path="/sign-up"
                signInUrl="/sign-in"
                fallbackRedirectUrl="/"
            />
            <AuthPageFooter />
        </div>
    );
}
